import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const PortfolioSingle = () => {

  // Get Portfolio details passed via router state
  const location = useLocation();
  const portfolio = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={portfolio.title} page={"Portfolio Single"} />

      <section className='portfolio-single page-single'>

        <div className='portfolio-info page-info'>

          {/* Portfolio Image */}
          <div className='image'>
            <img src={portfolio.image} alt={portfolio.title} />
          </div>

          <div className='content'>

            {/* Portfolio Title */}
            <h3 className='main-heading'>{portfolio.title}</h3>

            {/* Portfolio Description */}
            {portfolio.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Portfolio Image Gallery */}
            <Lightbox images={portfolio.gallery} />

            {/* Portfolio Challenges Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Portfolio Challenges:</h3>
              <p>Key challenges we faced while designing and bringing {portfolio.title} to life:</p>

              {/* List of Portfolio Challenges */}
              <ul>
                {portfolio.challenges.map((challenge, index) => {
                  return <li key={index}> <div className='icon'><FaCheck /></div> {challenge}</li>
                })}
              </ul>

            </div>

            {/* Portfolio Solution Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Portfolio Solutions:</h3>

              <p>Here’s how we brewed up creative solutions to overcome the challenges for {portfolio.title}:</p>

              {/*Portfolio Solutions List */}
              <ul>
                {portfolio.solutions.map((solution, index) => {
                  return <li key={index}> <div className='icon'><FaCaretRight /></div> {solution}</li>
                })}
              </ul>

            </div>

            {/* Portfolio Results Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Portfolio Results:</h3>
              <p>A closer look at the results and key highlights achieved through {portfolio.title}:</p>

              {/* Portfolio Results */}
              <ul>
                {portfolio.results.map((result, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{result}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Portfolio details */}
        <PageSidebar
          heading={'Portfolio'}
          details={portfolio.details}
        />

      </section>

    </> 
  );
}

export default PortfolioSingle;